export enum UserRole {
  Unauthorized = 'Unknown',
  Viewer = 'Viewer',
  Editor = 'Editor',
  AccountOwner = 'AccountOwner',
  Administrator = 'Administrator',
}
